(ns com.theplantscape.plant-web.api.polycultures
  (:require
   [com.theplantscape.plant-web.draw.api :refer [make-request-async]]
   [com.theplantscape.plant-web.draw.constants :refer [api-url-build]]
   [com.theplantscape.plant-web.draw.state :refer [site-state]]))

(defn fetch-polycultures
  ([] (fetch-polycultures "all" nil))
  ([list] (fetch-polycultures list nil))
  ([list version]
   (make-request-async
    {:method :get
     :uri (api-url-build "/api/v2/polyculture?list=" list)
     :headers {:authorization (-> @site-state :auth :access_token)}
     :params (merge {} (when version {:revision version}))})))


(defn delete-polyculture
  [id]
  (make-request-async
   {:method :delete
    :uri (api-url-build "/api/v2/polyculture/" id)
    :headers {:authorization (-> @site-state :auth :access_token)}}))


(defn fetch-polyculture
  ([id] (fetch-polyculture id nil))
  ([id version]
   (make-request-async
    {:method :get
     :uri (api-url-build "/api/v2/polyculture/" id)
     :headers {:authorization (-> @site-state :auth :access_token)}
     :params (merge {} (when version {:revision version}))})))


(defn create-new-polyculture
  [polyculture]
  (make-request-async
   {:method :post
    :uri (api-url-build "/api/v2/polyculture")
    :headers {:authorization (-> @site-state :auth :access_token)}
    :params polyculture}))

(defn create-new-revision-polyculture
  [id polyculture]
  (make-request-async
   {:method :put
    :uri (api-url-build "/api/v2/polyculture/" id)
    :headers {:authorization (-> @site-state :auth :access_token)}
    :params polyculture}))
